import React, {useEffect} from "react";
import './Exporter.sass';
import {Button, Checkbox, Input, Radio, Select, TimePicker} from 'antd';
import {map, findIndex} from 'lodash';
import locale from "antd/es/date-picker/locale/zh_CN";
import {shallowEqual} from "react-redux";
import OrderType from "../../utils/OrderType";
import DeliveryType from "../../utils/DeliveryType";
import moment from "moment";

const {useState} = require("react");
const Option = Select.Option;

const SearchConditions = (props) => {
    return <div className="searchCondition">
        <div className='flex contractName searchConditionItem'>
            <div>团购名称：</div>
            {props.contractName || '所有团购'}
        </div>

        <div className="flex searchConditionItem">
            <div>到货日期：</div>
            {props.arrivalDate && props.arrivalDate[0] ? (props.arrivalDate[0].format('YYYY-MM-DD') +
                '--' + props.arrivalDate[1].format('YYYY-MM-DD')) : '不限'}
        </div>

        <div className="flex searchConditionItem">
            <div>截单日期：</div>
            {props.endTime && props.endTime[0] ? (props.endTime[0].format('YYYY-MM-DD') +
                '--' + props.endTime[1].format('YYYY-MM-DD')) : '不限'}
        </div>
        <div className='flex searchConditionItem'>
            <div>团长/用户：</div>
            {props.mchOrUserName || '所有团长/用户'}
        </div>
        <div className="flex searchConditionItem">
            <div>订单状态：</div>
            {props.orderStatusDesc || '全部'}
        </div>
    </div>
}

const GroupsSelectorComponent = (props) => {
    const {fields, onSelectedChange} = props;
    return (<div className="fieldSelector">
        {
            fields.map((groupFields, index) => {
                return (<SelectGroupComponent
                    key={index}
                    groupIndex={index}
                    onSelectedChange={onSelectedChange}
                    fields={groupFields.fields}
                    title={groupFields.title}
                    available={groupFields.available}
                />);
            })
        }
    </div>)
}

const SelectGroupComponent = (props) => {
    const {onSelectedChange, title, fields, groupIndex, available} = props;
    const selectFields = [];
    if (available) {
        for (let i in fields) {
            if (fields[i]['selected']) {
                if (fields[i].available) {
                    selectFields.push(i);
                }
            }
        }
    }
    const onSelected = (keys) => {
        let selectFields = [];
        for (const key in fields) {
            if (keys.includes(key)) {
                fields[key].selected = true;
                selectFields.push(key);
            } else {
                fields[key].selected = false;
            }
        }
        onSelectedChange(fields, groupIndex);
        setSelectedFields([...selectFields]);
    }
    const [selectedFields, setSelectedFields] = useState(selectFields);
    if (!shallowEqual(selectedFields, selectFields)) {
        setSelectedFields([...selectFields]);
    }
    return (<Checkbox.Group
        value={selectedFields}
        onChange={onSelected}
    >
        <div className="fields table">
            <div className={'selectTitle tableCell ' + (available ? "" : ' disabled')}>{title}</div>
            <div className="selectItemWrapper tableCell">
                {map(fields, (item, index) => {
                    return (<Checkbox key={index} value={index}
                                      disabled={(available && item.available) ? null : true}>{item.title}</Checkbox>);
                })}
            </div>
        </div>
    </Checkbox.Group>);
}

const SelectOutputFileTypes = (props) => {
    const {strategies, onSelectedStrategies} = props;
    let selected = [];
    for (let i in strategies) {
        if (strategies[i].selected && strategies[i]['available']) {
            selected.push(strategies[i].strategy);
        }
    }
    const [selectedStrategies, setSelectedStrategies] = useState(selected);
    if (!shallowEqual(selectedStrategies, selected)) {
        setSelectedStrategies([...selected]);
    }
    if (selectedStrategies.length === 0) {
        selected = [];
        let index = findIndex(strategies, (item) => item['available']);
        if (index > -1) {
            let item = strategies[index];
            item.selected = true;
            selected.push(item.strategy);
            setSelectedStrategies([...selected]);
        }
    }
    const onSelected = (changedStrategies) => {
        let selected = [];
        if (changedStrategies.length > 0) {
            for (let i in strategies) {
                if (changedStrategies.includes(strategies[i].strategy)) {
                    strategies[i].selected = true;
                    selected.push(strategies[i].strategy);
                } else {
                    strategies[i].selected = false;
                }
            }
            setSelectedStrategies([...selected]);
            onSelectedStrategies(strategies);
        }
    }
    return (
        <Checkbox.Group
            className="selectOutputFileTypes"
            value={selectedStrategies}
            onChange={onSelected}
        >
            <div className="selectItemWrapper">
                {map(strategies, (item, index) => {
                    return <Checkbox className={"strategy " + (item['available'] ? '' : ' disabled')} key={index}
                                     value={item.strategy}
                                     disabled={item['available'] ? null : true}>{item.name}</Checkbox>
                })}
            </div>
        </Checkbox.Group>
    );
};

const customStrategies = [
    {
        name: '商户订单导出',
        strategy: 'CUSTOM_DEFINE_ORDER_EXPORT_STRATEGY',
        selected: true,
        available: true,
    },
    {
        name: '供应商品汇总单',
        strategy: 'PROVIDER_ORDER_PRODUCT_STRATEGY',
        selected: true,
        available: true,
    },
    {
        name: '团长商品汇总',
        strategy: 'POSITION_ORDER_EXPORT_STRATEGY',
        selected: true,
        available: true,
    },
    {
        name: '团长商品分拣单',
        strategy: 'POSITION_PRODUCT_TRANSVERSE_DIRECTION_STRATEGY',
        selected: true,
        available: true,
    },
    {
        name: '团长的用户商品汇总',
        strategy: 'POSITION_USER_ORDER_PRODUCT_STRATEGY',
        selected: true,
        available: true,
    },
];
const customExportFields = [
    {
        "fields": {
            'sale_merchant_name': {
                "title": "团长昵称",
                "selected": true,
                "available": true,
            },
            "sale_merchant_mobile": {
                "title": "团长联系方式",
                "selected": true,
                "available": true,
            },
            "sale_merchant_address": {
                "title": "团长地址",
                "selected": true,
                "available": true,
            },
        },
        "title": "团长信息",
        "key": "sale_merchant",
        "available": true,
    },
    {
        "fields": {
            "contract_name": {
                "title": "合约/团购名称",
                "selected": true,
                "available": true,
            },
            "contract_channel": {
                "title": "所属渠道",
                "selected": true,
                "available": true,
            },
            "contract_batch_end_time": {
                "title": "团购截单时间",
                "selected": true,
                "available": true,
            },
            "contract_batch_arrival_date": {
                "title": "团购到货时间",
                "selected": true,
                "available": true,
            },
        },
        "title": "团购信息",
        "key": "contract",
        "available": true,
    },
    {
        "fields": {
            'user_name': {
                "title": "用户昵称",
                "selected": true,
                "available": true,
            },
            "user_mobile": {
                "title": "用户电话",
                "selected": true,
                "available": true,
            },
        },
        "title": "用户信息",
        "key": "user",
        "available": true,
    },
    {
        "fields": {
            "order_id": {
                "title": "订单号",
                "selected": true,
                "available": true,
            },
            "order_paid_at": {
                "title": "支付时间",
                "selected": true,
                "available": true,
            },
            "order_payment_type": {
                "title": "支付方式",
                "selected": true,
                "available": true,
            },
            "delivery_type": {
                "title": "物流信息/配送类型",
                "selected": true,
                "available": true,
            },
            "order_payment_amount": {
                "title": "订单支付金额",
                "selected": true,
                "available": true,
            },
            "service_commission_amount": {
                "title": "圈子服务费",
                "selected": true,
                "available": true,
            },
            'order_batch_status': {
                "title": "订单状态",
                "selected": true,
                "available": true,
            },
            'order_refund_amount': {
                "title": '退款金额',
                "selected": true,
                "available": true,
            },
            'order_refund_at': {
                "title": '退款时间',
                "selected": true,
                "available": true,
            },
            'after_service_status': {
                "title": '售后状态',
                "selected": true,
                "available": true,
            },
            "order_remark": {
                "title": "备注",
                "selected": true,
                "available": true,
            }
        },
        "title": "订单信息",
        "key": "order",
        "available": true,
    },
    {
        "fields": {
            "product_name": {
                "title": "商品名称",
                "selected": true,
                "available": true,
            },
            "product_code": {
                "title": "商品编号",
                "selected": true,
                "available": true,
            },
            "product_spec": {
                "title": "商品规格",
                "selected": true,
                "available": true,
            },
            "product_price": {
                "title": "商品价格",
                "selected": true,
                "available": true,
            },
            "product_quantity": {
                "title": "购买数量",
                "selected": true,
                "available": true,
            },
            "product_amount": {
                "title": "商品金额",
                "selected": true,
                "available": true,
            },
            "product_service_commission_amount": {
                "title": "商品服务费",
                "selected": true,
                "available": true,
            },
            "product_sale_merchant_commission_amount": {
                "title": "团长商品佣金",
                "selected": true,
                "available": true,
            },
            "product_provider_merchant_amount": {
                "title": "商户货款",
                "selected": true,
                "available": true,
            },
        },
        "title": "商品信息",
        "key": "product",
        "available": true,
    },
];

const submitExportData = async (fields, strategies, searchCondition, remark, submit) => {
    let selectedStrategies = [];
    let selectedFields = [];
    for (let i in fields) {
        for (let key in fields[i]['fields']) {
            if (fields[i]['available'] && fields[i]['fields'][key]['selected'] && fields[i]['fields'][key]['available']) {
                selectedFields.push(key);
            }
        }
    }
    for (const i in strategies) {
        if (strategies[i].selected && strategies[i]['available']) {
            selectedStrategies.push(strategies[i].strategy);
        }
    }
    return await submit(selectedFields, selectedStrategies, searchCondition, remark);
}

const CustomDefineExporter = (props) => {
    const [name, setName] = useState('');
    const [fields, setFields] = useState([...customExportFields]);
    const [strategies, setStrategies] = useState([...customStrategies]);
    const {closePopup, submit, searchCondition} = props;
    const [remark, setRemark] = useState('')
    return <div className="exporterBoard">
        <div className="exporterPopupBg" onClick={() => closePopup()}/>
        <div className="exporterPopup">
            <div className="header">
                订单导出配置信息
            </div>
            <div className="content exporterPopupContent">
                <SearchConditions {...searchCondition}/>
                <div className="taskName table configuration remarkWrapper">
                    <label className="title tableCell width100">导出项目名称</label>
                    <Input className="taskNameInput tableCell" value={name} onChange={(e) => setName(e.target.value)}/>
                </div>
                <GroupsSelectorComponent fields={fields} onSelectedChange={(changeFields, index) => {
                    fields[index].fields = changeFields;
                    setFields(fields);
                }}/>
                <div className='configuration table remarkWrapper'>
                    <label className="title tableCell width100">添加备注</label>
                    <Input.TextArea className="configurationContent tableCell remarkInput" value={remark}
                                    placeholder='请输入' onChange={(e) => setRemark(e.target.value)}/>
                </div>
                <SelectOutputFileTypes strategies={strategies}
                                       onSelectedStrategies={(selectedStrategies) => setStrategies(selectedStrategies)}/>
            </div>
            <div className='popupFooter flex'>
                <Button onClick={() => {
                    closePopup();
                }}>关闭</Button>
                <Button onClick={async () => {
                    await submitExportData(fields, strategies, searchCondition, remark, submit);
                    closePopup();
                }}>生成报表</Button>
            </div>
        </div>
    </div>
};

const PeriodicalExporter = (props) => {
    const [name, setName] = useState('');
    const [fields, setFields] = useState([...customExportFields]);
    const [strategies, setStrategies] = useState([...customStrategies]);
    const [configurations, setConfigurations] = useState([...PeriodicalConfigurations]);
    const [remark, setRemark] = useState('')
    const [condition, setCondition] = useState({
        executeTime: moment('00:00', 'HH:mm'),
        containHours: 1,
        beforeDay: 0,
        rangeTimes: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
        orderType: OrderType.ALL_SUPPLY_PRODUCT_ORDERS,
        deliveryType: DeliveryType.SELF_PICK,
        summaryType: 'arrival_date'
    });
    const {closePopup, submit} = props;
    const disabledFields = (disabledFields = {}) => {
        for (const field of fields) {
            if (disabledFields[field.key] !== undefined) {
                if (disabledFields[field.key] === '*') {
                    field.available = false;
                } else {
                    for (const key in field.fields) {
                        if (disabledFields[field.key].includes(key)) {
                            field.fields[key].available = false;
                        } else {
                            field.fields[key].available = true;
                        }
                    }
                    field.available = true;
                }
            } else {
                field.available = true;
                for (const key in field.fields) {
                    field.fields[key].available = true;
                }
            }
        }
        setFields([...fields]);
    }
    const disabledStrategies = (disabledStrategies = []) => {
        for (const item of strategies) {
            if (disabledStrategies.includes(item.strategy)) {
                item.available = false;
            } else {
                item.available = true;
            }
        }
        setStrategies([...strategies]);
    }
    return <div className="exporterBoard periodicalExporter">
        <div className="exporterPopupBg" onClick={() => closePopup()}/>
        <div className="exporterPopup">
            <div className="header">
                订单定时导出配置
            </div>
            <div className="content exporterPopupContent">
                <div className="taskName configuration">
                    <label className="title tableCell width100">导出项目名称</label>
                    <Input className="taskNameInput" value={name} onChange={(e) => setName(e.target.value)}></Input>
                </div>
                <PeriodicalConfiguration
                    configurations={configurations} setConfigurations={setConfigurations}
                    condition={condition} setCondition={setCondition} disabledFields={disabledFields}
                    disabledStrategies={disabledStrategies}
                />
                <GroupsSelectorComponent fields={fields} onSelectedChange={(changeFields, index) => {
                    fields[index].fields = changeFields;
                    setFields(fields);
                }}/>
                <div className='configuration table remarkWrapper'>
                    <label className="title tableCell width100">添加备注</label>
                    <Input.TextArea className="configurationContent tableCell remarkInput"
                                    value={remark}
                                    placeholder='请输入'
                                    onChange={(e) => {
                                        setRemark(e.target.value);
                                    }}/>
                </div>
                <SelectOutputFileTypes strategies={strategies}
                                       onSelectedStrategies={(selectedStrategies) => setStrategies(selectedStrategies)}/>
            </div>
            <div className='popupFooter flex'>
                <Button onClick={() => {
                    closePopup();
                }}>关闭</Button>
                <Button onClick={async () => {
                    let result = await submitExportData(fields, strategies, condition, remark, submit);
                    if (result)
                        closePopup();
                }}>生成报表</Button>
            </div>
        </div>
    </div>
};
const PeriodicalConfigurations = [
    {
        "fields": {
            'supply_product_orders': {
                "title": "所有供货订单",
                "selected": true,
                "available": true,
                "value": OrderType.ALL_SUPPLY_PRODUCT_ORDERS,
            },
            "contract_orders": {
                "title": "合约订单",
                "selected": false,
                "available": true,
                "value": OrderType.CONTRACT_PRODUCT_ORDERS,
            },
            "merchant_sale_orders": {
                "title": "团购订单",
                "selected": false,
                "available": true,
                "value": OrderType.SELF_SALE_PRODUCT_ORDER,
            },
            "online_mall_orders": {
                "title": "商城订单",
                "selected": false,
                "available": true,
                "value": OrderType.ONLINE_MALL_ORDERS,
            },
            "offline_payment_orders": {
                "title": "扫码付订单",
                "selected": false,
                "available": true,
                "value": OrderType.OFFLINE_PAYMENT_ORDERS,
            },
        },
        "title": "汇总订单类型",
        "selected": "supply_product_orders",
        "available": true,
        "key": "orderType",
    },

    {
        "fields": {
            'merchant_send_orders': {
                "title": "自配送",
                "selected": true,
                "available": true,
                "value": DeliveryType.SELF_PICK,
            },
            "express_orders": {
                "title": "快递",
                "selected": false,
                "available": false,
                "value": DeliveryType.EXPRESS,
            },
        },
        "title": "物流方式",
        "selected": "merchant_send_orders",
        "available": true,
        "key": "deliveryType",
    },

    {
        "fields": {
            'arrival_date': {
                "title": "按到货时间汇总",
                "selected": true,
                "available": true,
                "value": "arrival_date",
            },
            "end_time": {
                "title": "按截单时间汇总",
                "selected": false,
                "available": true,
                "value": "end_time",
            },
            "paid_time": {
                "title": "按订单时间汇总",
                "selected": false,
                "available": true,
                "value": "paid_time",
            },
        },
        "title": "汇总方式",
        "selected": "arrival_date",
        "available": true,
        "key": "summaryType",
    },
];
const PeriodicalConfiguration = (props) => {
    const {configurations, setConfigurations, condition, setCondition, disabledFields, disabledStrategies} = props;
    return (<div className='periodicalConfigurationsWrapper'>
        {
            configurations.map((configuration, index) => {
                return (<div className="configuration" key={index}>
                    <div className="title">{configuration.title}</div>
                    <Radio.Group className="configurationContent"
                                 value={configuration.selected}
                                 onChange={(e) => {
                                     configuration.selected = e.target.value;
                                     condition[configuration.key] = configuration.fields[e.target.value]['value'];
                                     if (index === 0) {
                                         if (configuration.selected === 'online_mall_orders') {
                                             disabledFields({
                                                 'sale_merchant': "*",
                                                 'contract': "*",
                                                 'order': [
                                                     'service_commission_amount'
                                                 ],
                                                 'product': [
                                                     'product_service_commission_amount',
                                                     'product_sale_merchant_commission_amount',
                                                     'product_provider_merchant_amount',
                                                 ]
                                             });
                                             disabledStrategies([
                                                 'PROVIDER_ORDER_PRODUCT_STRATEGY',
                                                 'POSITION_ORDER_EXPORT_STRATEGY',
                                                 'POSITION_PRODUCT_TRANSVERSE_DIRECTION_STRATEGY',
                                                 'POSITION_USER_ORDER_PRODUCT_STRATEGY',
                                             ]);
                                             configurations[2].fields['arrival_date'].available = false;
                                             configurations[2].fields['arrival_date'].selected = false;
                                             configurations[2].fields['end_time'].available = false;
                                             configurations[2].fields['end_time'].selected = false;
                                             configurations[2].fields['paid_time'].available = true;
                                             configurations[2].fields['paid_time'].selected = true;
                                             configurations[2].selected = 'paid_time';
                                         } else if (configuration.selected === 'offline_payment_orders') {
                                             disabledFields({
                                                 'sale_merchant': "*",
                                                 'contract': "*",
                                                 'product': "*",
                                                 'order': [
                                                     'service_commission_amount'
                                                 ],
                                             });
                                             disabledStrategies([
                                                 'PROVIDER_ORDER_PRODUCT_STRATEGY',
                                                 'POSITION_ORDER_EXPORT_STRATEGY',
                                                 'POSITION_PRODUCT_TRANSVERSE_DIRECTION_STRATEGY',
                                                 'POSITION_USER_ORDER_PRODUCT_STRATEGY',
                                             ]);
                                             configurations[2].selected = 'paid_time';
                                             configurations[2].fields['end_time'].available = false;
                                             configurations[2].fields['end_time'].selected = false;
                                             configurations[2].fields['arrival_date'].available = false;
                                             configurations[2].fields['arrival_date'].selected = false;
                                             configurations[2].fields['paid_time'].available = true;
                                             configurations[2].fields['paid_time'].selected = true;
                                         } else {
                                             disabledFields();
                                             disabledStrategies();
                                             configurations[2].fields['paid_time'].available = true;
                                             configurations[2].fields['paid_time'].selected = true;
                                             configurations[2].selected = 'arrival_date';
                                             configurations[2].fields['arrival_date'].available = true;
                                             configurations[2].fields['arrival_date'].selected = false;
                                             configurations[2].fields['end_time'].available = true;
                                             configurations[2].fields['end_time'].selected = false;
                                         }
                                     }
                                     setConfigurations([...configurations]);
                                     setCondition({...condition});
                                 }}
                    >
                        {
                            map(configuration.fields,
                                (field, index) => (<Radio disabled={(field.available) ? null : true} value={index}
                                                          key={index}>{field.title}</Radio>))
                        }
                    </Radio.Group>
                </div>);
            })
        }
        <div className="configuration">
            <div className="title"/>
            <div className='configurationContent flex line alignCenter'>
                每天&nbsp; <TimePicker className='width100' value={condition.executeTime} onChange={(e, d) => {
                if (e) {
                    condition.executeTime = e;
                    setCondition({...condition});
                }
            }} locale={locale} format={'HH:mm'}/>&nbsp;，
                汇总&nbsp;

                {
                    configurations[2].selected === 'end_time' && (<>
                        前 <Input className='width100'
                                 value={condition.containHours}
                                 onChange={(e) => {
                                     condition.containHours = e.target.value;
                                     setCondition({...condition});
                                 }}/>个小时内 </>)
                }

                {
                    configurations[2].selected !== 'end_time' && (
                        <Select className='width100 beforeDay' value={condition.beforeDay} onChange={(e) => {
                            condition.beforeDay = e;
                            setCondition({...condition});
                        }}>
                            <Option value={0}>当日</Option>
                            <Option value={1}>前一天</Option>
                            <Option value={2}>前两天</Option>
                            <Option value={3}>前三天</Option>
                            <Option value={4}>前四天</Option>
                            <Option value={5}>前五天</Option>
                            <Option value={6}>前六天</Option>
                        </Select>
                    )
                }

                &nbsp;
                {
                    configurations[2].selected !== 'end_time' && (
                        <TimePicker.RangePicker value={condition.rangeTimes} format={'HH:mm'} locale={locale}
                                                onChange={(e, d) => {
                                                    if(e && e[0] && e[1]){
                                                        condition.rangeTimes = e;
                                                        setCondition({...condition});
                                                    }
                                                }}/>)
                }
                &nbsp;
                {
                    configurations[2].selected === 'arrival_date' ? ('到货的订单') : configurations[2].selected === 'end_time' ? ('所有截单的订单') : configurations[2].selected === 'paid_time' ? ('所有下单的订单') : null
                }

            </div>
        </div>
    </div>);
}
export {CustomDefineExporter, PeriodicalExporter};